import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { msalInstance } from "./msalConfig";

export const MSAL_LOGIN_SCOPES = ["User.Read"];

export const initializeMsal = () => msalInstance.initialize();

export const handleMsalRedirect = () => msalInstance.handleRedirectPromise();

export const initiateMsLogin = async () => {
  await msalInstance.loginRedirect({
    scopes: MSAL_LOGIN_SCOPES,
  });
};

export const acquireMsAccessToken = async (scopes = MSAL_LOGIN_SCOPES) => {
  const accounts = msalInstance.getAllAccounts();
  if (!accounts.length) {
    return null;
  }

  try {
    const result = await msalInstance.acquireTokenSilent({
      scopes,
      account: accounts[0],
    });
    return result.accessToken;
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      await msalInstance.acquireTokenRedirect({ scopes });
      return null;
    }
    throw error;
  }
};
